import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Observable, of, Subscription } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { RecipientPreviewService } from '../services/recipient-preview.service';
import { RecipientStory, RecipientNews } from '../services/recipient-repository.service';

@Component({ selector: 'app-recipient-preview', templateUrl: './recipient-detail.component.html', styleUrls: ['./recipients.scss'] })
export class RecipientPreviewComponent implements OnInit, OnDestroy, DwModalHandler {
  readonly returnPath = '/recipients';
  modalConfig: DwModalConfig<{ recipientId: number }>;
  closeModal = new EventEmitter<DwModalResult>();
  readonly preview = true;
  story: RecipientStory;
  updates: RecipientNews[] = [];
  loading = true; error = ''; updatesError = ''; updatesLoading = false;
  previewStatus = '';
  private updateStatuses: { [id: number]: string } = {};
  private subscription = new Subscription();
  private securitySubscription = new Subscription();
  constructor(private repository: RecipientPreviewService, private security: DwSecurityUserService) {}
  ngOnInit(): void {
    this.reload();
    this.securitySubscription = this.security.securityContextChanged().subscribe(() => {
      this.subscription.unsubscribe(); this.story = null; this.updates = [];
      const result = new DwModalResult(); result.closeModal = true; result.cancelled = true;
      this.closeModal.emit(result);
    });
  }
  reload(): void {
    this.subscription.unsubscribe(); this.subscription = new Subscription();
    this.loading = true; this.error = ''; this.story = null; this.updates = [];
    this.subscription.add(this.repository.load(this.modalConfig.data.recipientId).pipe(timeout(20000)).subscribe(result => {
      this.loading = false;
      if (!result) { this.error = 'This saved recipient could not be found.'; return; }
      this.story = result.story; this.updates = result.updates;
      this.previewStatus = result.status; this.updateStatuses = result.updateStatuses;
    }, () => { this.loading = false; this.error = 'Unable to load the preview. Check your admin access and try again.'; }));
  }
  updateStatus(update: RecipientNews): string { return this.updateStatuses[update.RecipientUpdateId] || ''; }
  buttonClick(button: DwButtonConfig): Observable<DwModalResult> {
    const result = new DwModalResult(); result.closeModal = true; result.cancelled = true; result.buttonCommand = button.command;
    return of(result);
  }
  ngOnDestroy(): void { this.subscription.unsubscribe(); this.securitySubscription.unsubscribe(); }
}
